export const USER_START = 'USER_START';
export const USER_SUCCESS = 'USER_SUCCESS';
export const USER_FAILURE = 'USER_FAILURE';
export const USER_RESET = 'USER_RESET';
export const GET_USER = 'GET_USER';
export const GET_USERS_BY_MONTH = 'GET_USERS_BY_MONTH';
export const USER_ADD = 'USER_ADD';
export const USER_DELETE = 'USER_DELETE';

export const USER_EDIT = 'USER_EDIT';
export const USER_PASSWORD_CHANGE = 'USER_PASSWORD_CHANGE';
export const GET_LOGGED_IN_USER = 'GET_LOGGED_IN_USER';
